import {createTheme} from '@mui/material/styles';

import themeOptions from './themeOptions';
import {overrides} from './overrides';

export const themeDecisions = createTheme(themeOptions({mode: 'light'}));

themeDecisions.components = overrides(themeDecisions);
